export const SENTRY_COMMON_ERROR_IGNORE_LIST = [
  'TypeError: Load failed',
  'TypeError: Failed to fetch',
  'TypeError: NetworkError when attempting to fetch resource.',
  'TypeError: cancelled',
  'TypeError: Cancelled',
  'message: cancelled',
  'cancelled',
  'ResizeObserver loop limit exceeded',
  'Receiving end does not exist'
]

export function sentryEnrichEvent(originalException) {
  const extra = {}
  if (originalException.message) {
    extra.message = originalException.message
  }
  if (originalException.config) {
    extra.config = originalException.config
  }
  if (originalException.request) {
    extra.request = originalException.request
  }
  if (originalException.response) {
    extra.response = originalException.response
  }

  return extra
}
